enum ServiceName {
    TOPUP = "TOPUP",
    MONEY_DELIVERY = "MONEY_DELIVERY",
    ARTICLE_DELIVERY = "ARTICLE_DELIVERY"
}

export default ServiceName;